/**
 * Translation resolver which returns a resolved promise only when
 * the translation service has been set up (it uses a language and
 * the ajax call getting the json with the language has been returned)
 */
angular.module('resolvers').Translation = ($translate) => {

    if (!CWCONFIG.language) {

        return false;

    }
    return $translate.use(CWCONFIG.language);

};

angular.module('resolvers').Translation.$inject = ['$translate'];



// WEBPACK FOOTER //
// ./scripts/common/resolvers/translation.js